





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { MapViewModel, MapService } from '../../api/map';
import { TimelineItemService, TimelineItemViewModel } from '../../api/timelineItem';

@Component({
})
export default class EditMap extends Vue {
  private mapService: MapService = new MapService();
  private mapData: MapViewModel = this.mapService.NewModel;
  private mapId: number = 0;
  private timelineItemService: TimelineItemService = new TimelineItemService();
  private timelineItemData: any[] = [];
  private loading: boolean = false;

  private rules = {
    timelineItemID: [{required: true, message: '请选择对象', trigger: 'blur'}],
    name: [{required: true, message: '请输入名称', trigger: 'blur'}],
  };

  private timelineItem_OnSearch(query: string) {
    if (query !== '') {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.timelineItemService.GetByName(query).then((response: any) => {
          this.timelineItemData = response;
        });
        // this.options = this.list.filter(item => {
        //   return item.label.toLowerCase()
        //     .indexOf(query.toLowerCase()) > -1;
        // });
      }, 200);
    } else {
      this.timelineItemData = [];
    }
  }

  @Emit('OnCancel')
  private btnCancel_OnClick() {

  }
  @Emit('OnSave')
  private OnSave(isCreate: boolean) {
    return isCreate;
  }

  private Edit(entity: MapViewModel) {
    this.timelineItemService.Get(entity.timelineItemID!).then((response: any) => {
      this.timelineItemData.push(response);
      this.mapId = entity.id!;
      this.mapData = entity;
      if (this.mapId === 0 && this.mapData.name === '') {
        this.mapData.name = response.name + '的行踪图';
      }
    });
  }

  private btnSave_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        if (this.mapId === 0 ) {
          this.mapService.Create(this.mapData).then((response: any) => {
            this.$message.success('保存成功');
            this.OnSave(true);
          });
        } else {
          this.mapService.Update(this.mapData).then((response: any) => {
            this.$message.success('保存成功');
            this.OnSave(false);
          });
        }
      }
    });
  }
}
